export default "__VITE_ASSET__QswvoYYG__"